/* ============================================================
   THEME ENHANCE — theme.js'ten SONRA yuklenir.
   theme.js'e hic dokunulmaz. Yaptiklari:

   1. "Hemen al" butonu  -> sepete ekleyip dogrudan odemeye gider
   2. "Su anda X kisi bakiyor" (yildizlarin ustunde)
   3. Kalan stok uyarisi (varyanta gore guncellenir)
   4. Ayni gun kargo geri sayimi + tahmini teslimat araligi
      - Kesim saatinden once ve hafta ici ise: geri sayim gosterilir.
      - Kesim saati gectiyse veya hafta sonuysa: geri sayim yerine
        siparisin hangi gun kargoya verilecegi yazilir (or. "maandag").
      - Tahmini teslimat araligi kargo gunune gore kayar.
============================================================ */
(function () {
  'use strict';

  var cfg = (window.theme && window.theme.enhance) || {};
  var routes = (window.theme && window.theme.routes) || {};
  var LANG = document.documentElement.lang || 'nl';

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function fill(text, token) {
    var parts = String(text || '').split(token);
    return { before: parts[0] || '', after: parts[1] || '' };
  }

  /* ---------------------------------------------------------
     1. "Hemen al"
     Capture fazinda dinleriz: document uzerindeki bubble fazli
     eski handler'dan ONCE calisir, stopImmediatePropagation ile
     onu devre disi birakiriz.
     Sepete ekleme, tarayicinin kendi form POST'u ile yapilir:
     Shopify urunu sunucu tarafinda sepete koyar, sonra
     return_to ile dogrudan odeme sayfasina yonlendirir.
  --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var qb = target.closest('[data-quickbuy]');
    if (!qb) return;

    var form = qb.closest('form[action$="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (qb.disabled) return;

    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) {
      showFormError(form, cfg.unavailableText || '');
      return;
    }

    qb.disabled = true;
    if (!qb.dataset.label) qb.dataset.label = qb.textContent;
    qb.textContent = '…';

    var returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    returnTo.value = (routes.root_url || '/').replace(/\/$/, '') + '/checkout';

    // form.submit() `submit` olayini tetiklemez -> AJAX handler devreye girmez.
    form.submit();
  }, true);

  function showFormError(form, message) {
    if (!message) return;
    var box = form.querySelector('[data-form-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'form-error';
      box.setAttribute('data-form-error', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  }

  /* ---------------------------------------------------------
     2. "Su anda X kisi bakiyor"
        Sayi tamamen rastgele, min-max arasi, 7'yi asla gecmez.
  --------------------------------------------------------- */
  var VIEW_HARD_MAX = 7;

  function viewingBounds() {
    var max = parseInt(cfg.viewingMax, 10);
    var min = parseInt(cfg.viewingMin, 10);
    if (isNaN(max)) max = 7;
    if (isNaN(min)) min = 2;
    max = Math.min(max, VIEW_HARD_MAX);
    min = Math.max(Math.min(min, max), 0);
    return { min: min, max: max };
  }

  function buildViewingEl(text, extraClass) {
    var b = viewingBounds();
    var seg = fill(text || '||N||', '||N||');

    var p = document.createElement('p');
    p.className = 'viewing-now' + (extraClass ? ' ' + extraClass : '');
    p.setAttribute('data-viewing-count', '');

    var dot = document.createElement('span');
    dot.className = 'viewing-now__pulse';
    dot.setAttribute('aria-hidden', 'true');
    p.appendChild(dot);

    var line = document.createElement('span');
    var num = document.createElement('span');
    num.setAttribute('data-viewing-number', '');

    var count = b.min + Math.floor(Math.random() * (b.max - b.min + 1));
    num.textContent = count;

    line.appendChild(document.createTextNode(seg.before));
    line.appendChild(num);
    line.appendChild(document.createTextNode(seg.after));
    p.appendChild(line);

    if (b.max > b.min) {
      (function drift() {
        setTimeout(function () {
          if (!p.isConnected) return;
          var next = count + (Math.random() < 0.5 ? -1 : 1);
          if (next < b.min) next = b.min + 1;
          if (next > b.max) next = b.max - 1;
          count = next;
          num.textContent = count;
          drift();
        }, 14000 + Math.random() * 20000);
      })();
    }
    return p;
  }

  /* Urun sayfasi ve hizli bakis: sayac fiyat+yildiz satirinin ALTINDA durur
     (o satir yoksa yildizlarin ustunde) */
  function injectViewingDetail(scope) {
    var root = scope || document;
    $$('.product__details, .quickview__body', root).forEach(function (box) {
      if (box.querySelector('[data-viewing-count]')) return;
      var el = buildViewingEl(cfg.viewingText);
      // Fiyat + yildiz tek satirda (.product__meta-row) ise sayac o satirin
      // ALTINA girer; aksi halde eskisi gibi yildizlarin ustunde durur.
      var rating = box.querySelector('.product__rating');
      if (rating) {
        var ratingRow = rating.closest && rating.closest('.product__meta-row');
        if (ratingRow) ratingRow.insertAdjacentElement('afterend', el);
        else rating.parentNode.insertBefore(el, rating);
        return;
      }
      var price = box.querySelector('.product__price');
      if (price) {
        var priceRow = price.closest && price.closest('.product__meta-row');
        if (priceRow) priceRow.insertAdjacentElement('afterend', el);
        else price.parentNode.insertBefore(el, price);
        return;
      }
      var actions = box.querySelector('.quickview__actions, .product__buy');
      if (actions) actions.parentNode.insertBefore(el, actions);
    });
  }

  /* Urun kartlari: yine yildizlarin ustunde */
  function injectViewingCards(scope) {
    if (!cfg.showViewingCards) return;
    $$('.card__info', scope || document).forEach(function (info) {
      if (info.querySelector('[data-viewing-count]')) return;
      var el = buildViewingEl(cfg.viewingTextShort || cfg.viewingText, 'viewing-now--card');
      var rating = info.querySelector('.card__rating');
      if (rating) { info.insertBefore(el, rating); return; }
      var price = info.querySelector('.card__price');
      if (price) { info.insertBefore(el, price); return; }
      info.appendChild(el);
    });
  }

  /* ---------------------------------------------------------
     3. Kalan stok
        Gercek envanterden okunur; uydurma sayi yok.
        Varyant (beden) degisince guncellenir.
  --------------------------------------------------------- */
  function stockMapFor(form) {
    var raw = form.getAttribute('data-variant-stock');
    if (raw) {
      try { return JSON.parse(raw); } catch (e) { /* yoksay */ }
    }
    return cfg.productStock || null;
  }

  function ensureStockEl(form) {
    var el = form.querySelector('[data-stock-left]');
    if (el) return el;
    el = document.createElement('p');
    el.className = 'stock-left';
    el.setAttribute('data-stock-left', '');
    el.hidden = true;
    var anchor = form.querySelector('.quickview__actions, .product__buy');
    if (anchor) anchor.parentNode.insertBefore(el, anchor);
    else form.appendChild(el);
    return el;
  }

  function updateStock(form) {
    var map = stockMapFor(form);
    if (!map) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField) return;

    var qty = map[String(idField.value)];
    var el = ensureStockEl(form);
    var threshold = parseInt(cfg.stockThreshold, 10);
    if (isNaN(threshold)) threshold = 10;

    if (typeof qty !== 'number' || qty <= 0 || qty > threshold) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    var text = qty === 1 ? (cfg.stockTextOne || cfg.stockText) : cfg.stockText;
    var seg = fill(text, '||N||');
    el.textContent = '';
    el.appendChild(document.createTextNode(seg.before));
    var strong = document.createElement('strong');
    strong.textContent = qty;
    el.appendChild(strong);
    el.appendChild(document.createTextNode(seg.after));
    el.hidden = false;
    el.classList.toggle('stock-left--critical', qty <= 3);
  }

  function bindStock(scope) {
    $$('form[action$="/cart/add"]', scope || document).forEach(function (form) {
      if (form.dataset.stockBound === '1') return;
      form.dataset.stockBound = '1';
      form.addEventListener('change', function () {
        setTimeout(function () { updateStock(form); }, 0);
      });
      updateStock(form);
    });
  }

  /* ---------------------------------------------------------
     4. Ayni gun kargo geri sayimi + tahmini teslimat
        Saatler magazanin saat dilimine gore hesaplanir,
        ziyaretcinin cihaz saatine gore degil.
  --------------------------------------------------------- */
  var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function shopNow(tz) {
    var opts = {
      timeZone: tz, hour12: false, weekday: 'short',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    };
    var parts = {};
    new Intl.DateTimeFormat('en-US', opts).formatToParts(new Date()).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    return {
      year: +parts.year,
      month: +parts.month,
      day: +parts.day,
      hour: (+parts.hour) % 24,
      minute: +parts.minute,
      second: +parts.second,
      dow: WEEKDAYS[parts.weekday]
    };
  }

  function cutoffInfo(tz, cutoffHour) {
    var n = shopNow(tz);
    var secNow = n.hour * 3600 + n.minute * 60 + n.second;
    var cutoffSec = cutoffHour * 3600;
    var days = 0;

    var isBusiness = n.dow >= 1 && n.dow <= 5;
    if (!(isBusiness && secNow < cutoffSec)) {
      days = 1;
      var d = (n.dow + 1) % 7;
      while (d === 0 || d === 6) { days++; d = (d + 1) % 7; }
    }
    return {
      now: n,
      remaining: days * 86400 + (cutoffSec - secNow),
      sameDay: days === 0,
      dispatchOffset: days
    };
  }

  function two(n) { return (n < 10 ? '0' : '') + n; }

  function formatRemaining(sec) {
    if (sec < 0) sec = 0;
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = Math.floor(sec % 60);
    return two(h) + ':' + two(m) + ':' + two(s);
  }

  /* Siparisin kargoya verilecegi gun. Hafta sonu ise cutoffInfo zaten
     pazartesiye kaydirmis olur; burada o gunu Date olarak uretiyoruz. */
  function dispatchDate(info) {
    var n = info.now;
    var base = new Date(Date.UTC(n.year, n.month - 1, n.day, 12));
    base.setUTCDate(base.getUTCDate() + info.dispatchOffset);
    return base;
  }

  /* Kargo gununun adi — magazanin diline gore (nl: "maandag"). */
  function dispatchDayName(info) {
    try {
      return new Intl.DateTimeFormat(LANG, { weekday: 'long', timeZone: 'UTC' })
        .format(dispatchDate(info));
    } catch (e) {
      return '';
    }
  }

  function deliveryRange(info) {
    var minD = parseInt(cfg.deliveryMinDays, 10);
    var maxD = parseInt(cfg.deliveryMaxDays, 10);
    if (isNaN(minD)) minD = 3;
    if (isNaN(maxD)) maxD = 5;

    var base = dispatchDate(info);

    function plus(d) {
      var x = new Date(base.getTime());
      x.setUTCDate(x.getUTCDate() + d);
      if (x.getUTCDay() === 0) x.setUTCDate(x.getUTCDate() + 1);
      return x;
    }
    var start = plus(minD);
    var end = plus(maxD);

    var fmtFull = new Intl.DateTimeFormat(LANG, { day: 'numeric', month: 'short', timeZone: 'UTC' });
    var sameMonth = start.getUTCMonth() === end.getUTCMonth();
    var startTxt = sameMonth
      ? new Intl.DateTimeFormat(LANG, { day: 'numeric', timeZone: 'UTC' }).format(start)
      : fmtFull.format(start);
    return startTxt + ' – ' + fmtFull.format(end);
  }

  function buildShipping() {
    var tz = cfg.shipTimezone || 'Europe/Amsterdam';
    var cutoffHour = parseInt(cfg.shipCutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 17;

    var info = cutoffInfo(tz, cutoffHour);

    var box = document.createElement('div');
    box.className = 'ship-info';
    box.setAttribute('data-ship-info', '');

    var row = document.createElement('p');
    row.className = 'ship-info__row ship-info__row--cutoff';
    var icon = document.createElement('span');
    icon.className = 'ship-info__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '🚚';
    row.appendChild(icon);

    var label = document.createElement('span');
    var timer = null;

    if (info.sameDay) {
      /* Hafta ici ve kesim saatinden once: "kadar verilen siparisler bugun
         kargoda" mesaji + kalan sureyi gosteren geri sayim. */
      var seg = fill(cfg.shipTextToday, '||T||');
      label.appendChild(document.createTextNode(seg.before));
      timer = document.createElement('strong');
      timer.className = 'ship-info__timer';
      timer.textContent = formatRemaining(info.remaining);
      label.appendChild(timer);
      label.appendChild(document.createTextNode(seg.after));
      row.className += ' ship-info__row--today';
    } else {
      /* Kesim saati gecti veya hafta sonu. Geri sayim burada 24 saati asip
         anlamsiz gorunuyordu; onun yerine kargo gununu yaziyoruz. */
      var segNext = fill(cfg.shipTextNext, '||W||');
      label.appendChild(document.createTextNode(segNext.before));
      var day = document.createElement('strong');
      day.className = 'ship-info__day';
      day.textContent = dispatchDayName(info);
      label.appendChild(day);
      label.appendChild(document.createTextNode(segNext.after));
      row.className += ' ship-info__row--next';
    }

    row.appendChild(label);
    box.appendChild(row);

    if (cfg.deliveryText) {
      var row2 = document.createElement('p');
      row2.className = 'ship-info__row ship-info__row--delivery';
      var icon2 = document.createElement('span');
      icon2.className = 'ship-info__icon';
      icon2.setAttribute('aria-hidden', 'true');
      icon2.textContent = '📦';
      row2.appendChild(icon2);

      var seg2 = fill(cfg.deliveryText, '||D||');
      var label2 = document.createElement('span');
      label2.appendChild(document.createTextNode(seg2.before));
      var range = document.createElement('strong');
      range.textContent = deliveryRange(info);
      label2.appendChild(range);
      label2.appendChild(document.createTextNode(seg2.after));
      row2.appendChild(label2);
      box.appendChild(row2);
    }

    /* Kesim saatine/gun donumune gelindiginde kutuyu bastan kurar,
       boylece "bugun kargoda" <-> "pazartesi kargoda" gecisi kendiliginden olur. */
    var left = info.remaining;
    var tick = setInterval(function () {
      if (!box.isConnected) { clearInterval(tick); return; }
      left--;
      if (left <= 0) {
        clearInterval(tick);
        var parent = box.parentNode;
        if (parent) parent.replaceChild(buildShipping(), box);
        return;
      }
      if (timer) timer.textContent = formatRemaining(left);
    }, 1000);

    return box;
  }

  function injectShipping() {
    if (!cfg.showShipping) return;
    $$('.product__details form[action$="/cart/add"]').forEach(function (form) {
      if (form.querySelector('[data-ship-info]')) return;
      var anchor = form.querySelector('.product__buy');
      if (anchor) anchor.parentNode.insertBefore(buildShipping(), anchor);
      else form.appendChild(buildShipping());
    });
  }

  /* --------------------------------------------------------- */
  function injectAll(scope) {
    if (cfg.showViewing) {
      injectViewingDetail(scope);
      injectViewingCards(scope);
    }
    bindStock(scope);
  }

  function start() {
    injectAll(document);
    injectShipping();

    var qv = document.getElementById('quickview-content');
    if (qv && window.MutationObserver) {
      new MutationObserver(function () { injectAll(qv); }).observe(qv, {
        childList: true, subtree: true
      });
    }

    if (window.MutationObserver) {
      $$('[data-recently-viewed]').forEach(function (root) {
        new MutationObserver(function () { injectViewingCards(root); }).observe(root, {
          childList: true
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
